import React, {useState} from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';



export default function Modal_Loading({subClass, text, show}) {
  //const classes = useStyles();
  //const [show, setShow] = useState(false);
  const [statusText, setStatusText] = useState('Your Translation is being processed..');
  const [contentClassName, setContentClassName] = useState('processing');

  setTimeout(function(){
    setContentClassName(subClass);
    setStatusText(text);
    //console.log("MODAL LOADING:")
    //console.log("subclass: " + subClass + " text: " + text)
  },2000);

  return (
    
    <div>
        {show ? 
            (<div className='load-modal-backdrop'>
                <div style={{display: 'flex', justifyContent: 'center', marginTop: '16%', zindex:'998'}}>
                    <CircularProgress size={220} color="primary"/>
                </div>
                <div className='matt-snack'>
                  <p className={`matt-snack-content matt-snack-content-${contentClassName}`}>{statusText}</p>
                </div>
            </div>)
            : (<></>)
        }
    </div>
  );
}
